/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var GetExternalExamTaskDetails = require('../../services/GetExternalExamTaskDetails');
var SecExternalExamResponseTaskView = require('./SecExternalExamResponseTaskView');

module.exports = {
  event: 'build:sc:rfi-subsequent-request-response',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();
    var examId = task.taskData.SC.scExamId;

    GetExternalExamTaskDetails(examId)
      .done(function(exam) {
        NProgress.set(0.85);
        defer.resolve(
          new SecExternalExamResponseTaskView({
            model: new Backbone.Model({
              task: task,
              taskId: task.taskId,
              examId: examId,
              exam: exam
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });
    return defer.promise();
  }
};
